import { createContext } from 'react';
import { AdvertDetailContextType } from '#advertDetail/contexts';

const AdvertDetailContext = createContext<AdvertDetailContextType>(null);

export { AdvertDetailContext };
